import RootLayout from '../Layout';
import WorkflowCreate from './Create';
import WorkflowDetail from './WorkflowDetail';
import WorkflowList from './WorkflowList';
import WorkflowRuns from './WorkflowRuns';

const routes = [
  {
    path: '',
    element: <RootLayout />,
    children: [
      {
        path: '',
        element: <WorkflowList />,
      },
    ],
  },
  {
    path: 'create',
    element: <WorkflowCreate />,
  },
  {
    path: ':id',
    element: <WorkflowDetail />,
  },
  {
    path: ':id/runs',
    element: <WorkflowRuns />,
  },
];

export default routes;
